export default __webpack_public_path__ + "static/media/P10009.90782052.png";